<template>
  <div class="row myrow content-mb-42" v-if="$parent.$parent.rerender">
    <div
      class="col-xs-12 mycol"
      v-bind:class="{
        'has-error': $parent.$parent.checkErrorField(
          'PROJECTS',
          'LOGIC',
          'UF_IS_REESTR_USING_RM'
        )
      }"
    >
      <select
        :disabled="$parent.$parent.projectDisabled"
        v-model="project.SETTING_TABLE.allData.UF_IS_REESTR_USING_RM"
        class="sel-dropdown i-main-style i-wid-13"
        v-on:change="
          $parent.$parent.removeError('PROJECTS', 'LOGIC', 'UF_IS_REESTR_USING_RM')
        "
      >
        <option :value="0">Нет</option>
        <option :value="1">Да</option>
      </select>

      <div class="error-text">
        {{
          $parent.$parent.checkErrorText(
            "PROJECTS",
            "LOGIC",
            "UF_IS_REESTR_USING_RM"
          )
        }}
      </div>
    </div>
    <div
      class=""
      v-if="project.SETTING_TABLE.allData.UF_IS_REESTR_USING_RM && project.SETTING_TABLE.allData.UF_IS_REESTR_USING_RM === 1"
    >
      <br /><br />
      <p class="content-s-2-label">
        <label
          >Номер записи в Реестре и доля используемого вторичного сырья:</label
        >
      </p>
      <div
        class="col-xs-12 mycol"
        :class="{
          'has-error': $parent.$parent.checkErrorField(
            'PROJECTS',
            'LOGIC',
            'UF_NUMBER_REESTR_USING_RM'
          )
        }"
      >
        <textarea
          class="i-main-style t-dop-style i-wid-50"
          v-model="project.SETTING_TABLE.allData.UF_NUMBER_REESTR_USING_RM"
          placeholder=""
          style="resize: vertical;"
          v-on:keyup="
           $parent.$parent.removeError('PROJECTS', 'LOGIC', 'UF_NUMBER_REESTR_USING_RM')
         "
        ></textarea>
        <div class="error-text">
          {{
            $parent.$parent.checkErrorText(
              "PROJECTS",
              "LOGIC",
              "UF_NUMBER_REESTR_USING_RM"
            )
          }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "uf_is_reestr_using_rm",
  computed: {
    ...mapGetters(["directory", "project"])
  }
};
</script>

<style scoped></style>
